import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
// enums
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
// actions
import { TMainPageLayout } from "../type";
// interfaces
import IClientLanguage from "core/interfaces/IClientLanguage";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";
import { Link } from "react-router-dom";
import CounterUp from "components/CounterUp";
import ApplicationDocumentSelector from "cms/utilities/ApplicationDocumentSelector";
import IApplicationDocument from "cms/interfaces/IApplicationDocument";
import { EResourceType } from "cms/enums/EResourceType";
import CoreDefault from "core/Defaults";
import { isEmpty } from "lodash";
import SanitizeHTMLString from "cms/utilities/SanitizeHTMLString";
import useProgressiveImage from "core/hooks/useProgressiveImage";


function mapStateToProps ( state: any ) {
    console.log("MNPG005.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail     = state.SiteSettingStore.details?.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload,
    
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("MNPG005.mapDispatchToProps");

    return {

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>


/* component */
function MMNPG005Loader () {

    return (
        <></>
    )

}

function MNPG005 ( props:TMainPageLayout<PropsFromRedux> ) {
    console.log("MNPG005.rendered", props)

    const parentLanguageVersion = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.MAIN_PAGE_ITEM },
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
        ],
        type: "find"
    });

    const yearsOfExperienceString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "yearsOfExperienceString" }
        ],
        type: "find"
    });

    const yearsOfExperience = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "yearsOfExperience" }
        ],
        type: "find"
    });

    const projectString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "projectString" }
        ],
        type: "find"
    });

    const project = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "project" }
        ],
        type: "find"
    });

    const corporateReferenceString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "corporateReferenceString" }
        ],
        type: "find"
    });

    const corporateReference = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "corporateReference" }
        ],
        type: "find"
    });

    const productivityString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "productivityString" }
        ],
        type: "find"
    });

    const productivity = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "productivity" }
        ],
        type: "find"
    });

    const outerImage = ApplicationDocumentSelector<IApplicationDocument|null>({
        resources: props.parentPayload.resources,
        resourceType: EResourceType.OUTER_IMAGE,
        type: "find"
    });

    const emailString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.childsPayload?.[0]?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "emailString" }
        ],
        type: "find"
    });

    const email = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.childsPayload?.[0]?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "email" }
        ],
        type: "find"
    });

    const phoneNumberString = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.childsPayload?.[0]?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "phoneNumberString" }
        ],
        type: "find"
    });

    const phone01 = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.childsPayload?.[0]?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "phone01" }
        ],
        type: "find"
    });

    const phone02 = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.childsPayload?.[0]?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "phone02" }
        ],
        type: "find"
    });


    const loaded = useProgressiveImage({ src:outerImage?.filePath ? `${CoreDefault.cdn}/${outerImage.filePath.replace("\\", "/")}` : null });
    console.log("MNPG005.loaded", loaded);

    return (
        <>
            <section className="why-choose-three">
                <div 
                    className="why-choose-three__bg"
                    style={loaded?{backgroundImage: `url('${loaded}')`}:undefined}
                />
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-7">
                            <div className="why-choose-three__left">
                                
                                <div className="ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(parentLanguageVersion?.value)}} />

                                {/* <div className="section-title text-left">
                                    <div className="section-title__tagline-box">
                                        <span className="section-title__tagline">{parentLanguageVersion?.name}</span>
                                    </div>
                                    <h2 className="section-title__title ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(parentLanguageVersion?.value)}} />
                                </div>
                                <p className="why-choose-three__text ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(parentLanguageVersionDescription?.value)}} /> */}

                                <div className="why-choose-three__btn-box">
                                </div>

                                <ul className="why-choose-three__contact-list list-unstyled">
                                    <li>
                                        <div className="icon">
                                            <span className="icon-phone-call"></span>
                                        </div>
                                        <div className="content">
                                            <span>{phoneNumberString?.value}</span>
                                            <p>
                                                {phone01?.value}<br />
                                                {phone02?.value}
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span className="icon-Group"></span>
                                        </div>
                                        <div className="content">
                                            <span>{emailString?.value}</span>
                                            <p>
                                                {email?.value}<br />
                                                &nbsp;
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="counter-three">
                <div className="container">
                    <div className="counter-three__inner">
                        <ul className="counter-three__count-list list-unstyled">
                            <li>
                                <div className="counter-three__big-count count-box">
                                <CounterUp end={parseInt(yearsOfExperience?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <div className="counter-three__count count-box">
                                <CounterUp end={parseInt(yearsOfExperience?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <p className="counter-three__text ck-content" dangerouslySetInnerHTML={{ __html: yearsOfExperienceString?.value?.replace(" ", "<br/>")||""}} />
                            </li>
                            <li>
                                <div className="counter-three__big-count count-box">
                                <CounterUp end={parseInt(project?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <div className="counter-three__count count-box">
                                <CounterUp end={parseInt(project?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <p className="counter-three__text ck-content" dangerouslySetInnerHTML={{ __html: projectString?.value?.replace(" ", "<br/>")||""}} />
                            </li>
                            <li>
                                <div className="counter-three__big-count count-box">
                                <CounterUp end={parseInt(corporateReference?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <div className="counter-three__count count-box">
                                <CounterUp end={parseInt(corporateReference?.value||"0")} />
                                    <span>+</span>
                                </div>
                                <p className="counter-three__text ck-content" dangerouslySetInnerHTML={{ __html: corporateReferenceString?.value?.replace(" ", "<br/>")||""}} />
                            </li>
                            <li>
                                <div className="counter-three__big-count count-box">
                                <CounterUp end={parseInt(productivity?.value||"0")} />
                                    <span>%</span>
                                </div>
                                <div className="counter-three__count count-box">
                                <CounterUp end={parseInt(productivity?.value||"0")} />
                                    <span>%</span>
                                </div>
                                <p className="counter-three__text ck-content" dangerouslySetInnerHTML={{ __html: productivityString?.value?.replace(" ", "<br/>")||""}} />
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
        
    );

}

const Component = React.memo(MNPG005, ( prevProps: TMainPageLayout<PropsFromRedux>, nextProps: TMainPageLayout<PropsFromRedux> ) => {
    return true;
});

export default connector(Component);
